import * as constants from './FreeModeBook.constants';
import * as services from './FreeModeBook.service';

import { storeFactory } from '@/scripts/FreeMode/FreeModeBook/FreeModeBook.store';

export default storeFactory(constants, services);
